import { PVCurve } from '@/dto/scenario/pv/PVCurve';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class PVCurveExt extends DtoExt {

  public static fromDto(dto: PVCurve): PVCurveExt {
    return new PVCurveExt({
      values: dto.values,
      durationYear: dto.durationYear,
      startDate: dto.startDate && DtoExt.localeDateFromUtc(dto.startDate),
      stepMinutes: dto.stepMinutes
    } as any);
  }

  public values: number[] | null = null;

  public durationYear: number | null = null;

  public startDate: Date | null = null;

  public stepMinutes: number | null = null;

  constructor(options?: Partial<PVCurveExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      // this.values = options.values;
      // this.durationYear = options.durationYear;
      // this.startDate = options.startDate;
      // this.stepMinutes = options.stepMinutes;
    }
  }

  public toDto(): PVCurve {
    return new PVCurve({
      values: this.values,
      durationYear: this.durationYear,
      startDate: DtoExt.localeDateToUtc(this.startDate),
      stepMinutes: this.stepMinutes
    });
  }
}
